// extracted by mini-css-extract-plugin
export default {"root":"bubble-count__root__xm2Ao"};